import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sdx-form',
  templateUrl: './sdx-form.component.html',
  styleUrls: ['./sdx-form.component.scss']
})
export class SdxFormComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void { }

  goToApplication() {
    window.open('https://corella.ren.apps.ge.com/innovator');
  }
}
